var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FiInfo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49992 8.74992C7.57099 8.74992 9.24992 7.07099 9.24992 4.99992C9.24992 2.92885 7.57099 1.24992 5.49992 1.24992C3.42885 1.24992 1.74992 2.92885 1.74992 4.99992C1.74992 7.07099 3.42885 8.74992 5.49992 8.74992ZM10.0833 4.99992C10.0833 7.53122 8.03122 9.58325 5.49992 9.58325C2.96861 9.58325 0.916586 7.53122 0.916586 4.99992C0.916586 2.46861 2.96861 0.416586 5.49992 0.416586C8.03122 0.416586 10.0833 2.46861 10.0833 4.99992Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50008 5.41675C5.26996 5.41675 5.08342 5.2302 5.08342 5.00008V3.33341C5.08342 3.1033 5.26996 2.91675 5.50008 2.91675C5.7302 2.91675 5.91675 3.1033 5.91675 3.33341V5.00008C5.91675 5.2302 5.7302 5.41675 5.50008 5.41675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91675 6.66659C5.91675 6.8967 5.7302 7.08325 5.50008 7.08325H5.49591C5.2658 7.08325 5.07925 6.8967 5.07925 6.66659C5.07925 6.43647 5.2658 6.24992 5.49591 6.24992H5.50008C5.7302 6.24992 5.91675 6.43647 5.91675 6.66659Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.88572f3c7edd0b2f1263aee52020b95b.svg";
export { ForwardRef as ReactComponent };